<template>
  <div class="user-add-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <div class="title">公司管理</div>
      <div class="box">
        <div class="form">
          <el-form
            ref="form"
            :class="{ formedit: editflge }"
            :rules="rules"
            :model="form"
            label-width="160px"
          >
            <div v-if="adminEdit">
              <el-row
                :gutter="5"
                style="
                  text-align: right;
                  margin-bottom: 10px;
                  margin-left: 58px;
                "
              >
                <el-button
                  type="primary"
                  v-if="!editflge"
                  @click="editflge = !editflge"
                  class="rigth"
                  v-hasPermi="['公司管理', '编辑']"
                  >编辑</el-button
                >
                <el-button
                  type="primary"
                  v-if="editflge"
                  @click="editflge = !editflge"
                  class="rigth"
                  >取消编辑</el-button
                >
              </el-row>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司名称" prop="companyName">
                  <el-input
                    v-model="form.companyName"
                    :disabled="!editflge"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="公司地址">
                  <el-input
                    v-model="form.address"
                    :disabled="!editflge"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司联系人">
                  <el-input
                    v-model="form.contact"
                    :disabled="!editflge"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话">
                  <el-input
                    v-model="form.phone"
                    :disabled="!editflge"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司性质" prop="companyCode">
                  <el-select
                    v-model="form.companyCode"
                    @change="companyChange"
                    :disabled="!editflge"
                    placeholder="请选择"
                    style="width: 100%; display: inline-block"
                  >
                    <el-option
                      v-for="item in options.code"
                      :key="item.id"
                      :label="item.codeName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="标题" prop="title">
                  <el-input
                    v-model="form.title"
                    :disabled="!editflge"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="所属公司"
                  v-show="!isShowSelect"
                  prop="parentCompId"
                >
                  <template v-if="editflge">
                    <el-select
                      v-model="form.parentCompId"
                      placeholder="请选择"
                      style="width: 100%; display: inline-block"
                    >
                      <el-option
                        v-for="item in options.parentCompOptions"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <el-select
                      v-model="form.parentCompId"
                      disabled
                      placeholder="请选择"
                      style="width: 100%; display: inline-block"
                    >
                      <el-option
                        v-for="item in options.parentCompOptions"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
            </el-row> -->
          </el-form>
          <div class="btns" v-if="editflge">
            <el-button type="primary" @click="submitForm('form')"
              >保存信息</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { detailCompany, updateCompany, selectCompanyData } from '@/api/company'
export default {
  data () {
    return {
      editflge: false,
      adminEdit: true,
      isShowSelect: false,
      rules: {
        companyName: [
          { required: true, message: '请输入公司名!', trigger: 'blur' },
        ],
        companyCode: [
          { required: true, message: '请输入公司性质!', trigger: 'blur' }
        ],
        parentCompId: [
          { required: true, message: '请输入所属公司!', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入标题!', trigger: 'blur' }
        ],
        parentCompanyName: [
          { required: true, message: '请输入所属部门!', trigger: 'blur' }
        ]
      },
      normalizer (node) {
        console.log(node)
        if (node.children && !node.children.length) {
          delete node.children
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children
        }
      },
      form: {
        id: '',
        parentCompId: null,
        companyCode: null,
      },
      options: {
        comp: [],
        code: [{ id: 0, codeName: '总公司' },
        { id: 1, codeName: '4S店' },
        { id: 2, codeName: '自定义服务部门' }],
        parentCompOptions: []
      },
      companyData: [],
      currentCompId: ''
    }
  },
  created () {
    this.id = this.$route.query.id
    this.companyCode = this.$route.query.company_code
    if (this.companyCode == 0) {
      this.isShowSelect = true
      this.rules.parentCompanyName = [{ required: false, message: '请输入所属部门!', trigger: 'blur' }]
    }
    this.initCompanyData()
    this.initFormData()
  },
  methods: {
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.id = this.$route.query.id
          updateCompany(this.form).then(res => {
            this.$message.success('修改成功!')
            this.$router.back(-1)
          })
        } else {
          return false
        }
      })
    },
    //公司性质选中事件
    companyChange () {
      let companyCode = this.form.companyCode
      if (companyCode === 0) {
        this.isShowSelect = true
        this.rules.parentCompId = [{ required: false, message: '请输入所属部门!', trigger: 'blur' }]
      } else {
        this.isShowSelect = false
        this.rules.parentCompId = [{ required: true, message: '请输入所属部门!', trigger: 'blur' }]
      }
      this.clearDataOptions()
      this.initCompanyOptions(companyCode)
    },
    initCompanyData () {
      selectCompanyData().then(res => {
        this.companyData = res.data
      })
    },
    initFormData () {
      const params = { id: this.id }
      detailCompany(params).then(res => {
        if (res.code == 0) {
          if (res.data.companyCode != null) {
            res.data.companyCode = Number(res.data.companyCode)
          }
          if (res.data.parentCompId != null) {
            res.data.parentCompId = Number(res.data.parentCompId)
          }
          this.initDetailValue(res.data)
        } else {
          let msg = res.message
          this.$message.error(this.isNotEmpty(msg) ? msg : "查询异常!")
        }
      })
    },
    initDetailValue (returnData) {
      this.initCompanyOptions(returnData.companyCode)
      this.form = returnData
    },
    initCompanyOptions (companyCode) {
      const belongCompany = JSON.parse(localStorage.user).belongCompany

      if (companyCode == 1 || companyCode == 2) {//4s店 或 部门
        this.companyData.forEach(el => {
          if (el.company_id == belongCompany) {
            this.options.parentCompOptions.push(el)
          }
        })
      } else if (companyCode == 3) {
        this.options.parentCompOptions = this.companyData
      }
    },
    //非空判断
    isNotEmpty (str) {
      if (str != null && str != '' && str.trim().length > 0) {
        return true
      }
      return false
    },
    //清理租赁公司
    clearDataOptions () {
      this.form.parentCompId = null
      this.options.parentCompOptions = []
    }
  }
}
</script>

<style lang="less" scoped>
.user-add-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .title {
      font-size: 18px;
      line-height: 40px;
      font-weight: bold;
      color: #1f7eb8;
    }
    .box {
      display: flex;
      padding-top: 30px;
      .btns {
        padding: 30px 160px 60px;
      }
      .avatar {
        .img {
          padding: 30px 10px;
          border: 1px solid #bbb;
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        max-width: 1100px;
      }
    }
  }
  #map-container {
    width: 100%;
    height: 400px;
    box-shadow: 0 0 10px 1px #acacac;
  }
}
</style>
<style lang="less">
.equipment-add-container {
  .el-form-item__label {
    color: #1a2550;
    padding: 0 30px 0 0;
  }
  .el-select,
  .el-input {
    width: 100%;
  }
}
.formedit {
  input::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #fff !important;
  }
  i {
    display: none;
  }
  .el-input.is-disabled .el-input__inner {
    cursor: auto;
    background-color: #fff;
    border: 0;
  }
}
</style>